import { render, staticRenderFns } from "./NewCorporativeAccount.vue?vue&type=template&id=8955f93c"
import script from "./NewCorporativeAccount.vue?vue&type=script&lang=js"
export * from "./NewCorporativeAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports